module.exports = __webpack_public_path__ + "static/media/QRcode.08dac6b1.jpg";